export default __webpack_public_path__ + "static/media/avatar_85.3bae6fd5.png";